import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateClusterStatus = {
  name: "updateClusterStatus" as const,
  input: z.object({
    clusterId: zExt.objectId(),
    status: z.enum(["pending", "approved", "rejected", "deferred", "shipped"]),
  }),
  output: z.object({ success: z.boolean() }),
};
